import Button from 'components/Button';
import Modal from 'components/Modal';
import React, { forwardRef, Ref, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';
import image_gift_card from './gift-card.png';

const ContainerStyled = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  .modal-title {
    color: #1D2129;
    font-family: Poppins;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    margin-bottom: 24px;
  }

  .image-gift-card {
    width: 180px;
    height: 180px;
    object-fit: cover;
  }

  .action-item {
    display: flex;
    padding: 24px 16px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    flex: 1 0 0;
    border-radius: 8px;
    border: 1px solid #86909C;
    background: #FFF;
    box-shadow: 0px 2px 4px 0px rgba(44, 35, 66, 0.40), 0px 4px 8px -3px rgba(45, 35, 66, 0.30), 0px -3px 0px 0px #D6D6E7 inset;

    span {
      color: #1D2129;
      text-align: center;
      font-family: Poppins;
      font-size: 18px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }

    &:hover {
      background: #F5F5F5;
      cursor: pointer;
    }
  }

  .action-item img.icon {
    width: 64px;
    height: 64px;
  }

  .content-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    align-self: stretch;
    padding: 0px 24px;

    .actions {
      display: flex;
      align-items: center;
      gap: 16px;
      align-self: stretch;
      padding: 32px 0;
    }

  }
`;
type Props = {};
export type ModalChooseNextPaymentRef = {
  open: (callback: (type: 'GIFT_CARD' | 'MULTI_PAY') => void) => void;
};
export const useModalChooseNextPaymentRef = () => useRef<ModalChooseNextPaymentRef>(null);
const ModalChooseNextPayment = forwardRef<ModalChooseNextPaymentRef, Props>(({ }, ref) => {
  const [open, setOpen] = useState(false);
  const callbackRef = useRef<((type: 'GIFT_CARD' | 'MULTI_PAY') => void) | null>(null);
  const onClose = () => setOpen(false);
  const onOpen: ModalChooseNextPaymentRef['open'] = (callback) => {
    callbackRef.current = callback || (() => undefined);
    setOpen(true);
  };

  const onChoose = (type: 'GIFT_CARD' | 'MULTI_PAY') => {
    callbackRef.current?.(type);
    onClose();
  };

  useImperativeHandle(ref, () => ({
    open: onOpen
  }));

  return (
    <Modal hiddenHeader hiddenFooter visible={open} onClose={onClose} width={900} noneBodyStyle noneFooterStyle>
      <ContainerStyled>
        <div className='content-container'>
          <img src={image_gift_card} alt='image-gift-card' className='image-gift-card' />
          <p className='modal-title'>Do you have another gift card to process the payment?</p>
          <div className='actions'>
            <Button block ntype='SECONDARY' cardCashier onClick={() => onChoose('MULTI_PAY')}><span style={{ fontSize: 20 }}>NO</span></Button>
            <Button block ntype='PRIMARY' cardCashier onClick={() => onChoose('GIFT_CARD')}><span style={{ fontSize: 20, color: '#fff' }}>YES</span></Button>
          </div>
        </div>
      </ContainerStyled>
    </Modal>
  );
});
ModalChooseNextPayment.displayName = 'ModalChooseNextPayment';
export default ModalChooseNextPayment;
